// Action type constants for the Widgets slice. `as const` gives each value a literal string type.
const actions = {
  SET_STATE: 'widgets/SET_STATE',
  CHAT_WIDGETS_LIST: 'widgets/CHAT_WIDGETS_LIST',
  GET_CHAT_WIDGET: 'widgets/GET_CHAT_WIDGET',
  ADD_CHAT_WIDGET: 'widgets/ADD_CHAT_WIDGET',
  UPDATE_CHAT_WIDGET: 'widgets/UPDATE_CHAT_WIDGET',
} as const

export default actions
